// import { createSlice } from '@reduxjs/toolkit'

// const initialState = {
//   data: null,
//   activeNetwork: null,
//   availNetworks: [],
//   token: null,
//   evmKey: null,
//   activeToken: [],
// }

// export const userSlice = createSlice({
//   name: 'user',
//   initialState,
//   reducers: {
//     setUser: (state, action) => {
//       state.data = action.payload;
//     },
 
//     clearUser: (state) => {
//       state.data = null;
//       state.token = null;
//       state.evmKey = null;
//       state.activeNetwork = null;
//       state.activeToken = [];
//     },
    
//     ActiveNetwork: (state, action) => {
//       state.activeNetwork = action.payload;
//     },
//     availNetworks: (state, action) => {
//       state.availNetworks = action.payload;
//     },
//     setToken: (state, action) => {
//       state.token = action.payload;
//     },
//     setEvmKey: (state, action) => {
//       state.evmKey = action.payload;
//     },
//     setActiveToken: (state, action) => {
//       state.activeToken = action.payload;
//     },
//   },
// })

// // Action creators are generated for each case reducer function
// export const { setUser, clearUser, ActiveNetwork, availNetworks, setToken, setEvmKey, setActiveToken } = userSlice.actions

// export default userSlice.reducer

import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  data: null,
  activeNetwork: null,
  availNetworks: [],
  token: null,
  evmKey: null,
  activeToken: [],
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.data = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    setEvmKey: (state, action) => {
      state.evmKey = action.payload
    },
    setActiveToken: (state, action) => {
      state.activeToken = action.payload
    },
    ActiveNetwork: (state, action) => {
      state.activeNetwork = action.payload
    },
    availNetworks: (state, action) => {
      state.availNetworks = action.payload
    },
    // ← only one clearUser, and only ever call it on logout
    clearUser: (state) => {
      state.data = null
      state.token = null
      state.evmKey = null
      state.activeNetwork = null
      state.activeToken = []
    },
  },
})

export const {
  setUser,
  setToken,
  setEvmKey,
  setActiveToken,
  ActiveNetwork,
  availNetworks,
  clearUser,
} = userSlice.actions

export default userSlice.reducer
